const userImageModules = import.meta.glob<string>(
  '../assets/users/*.{jpg,jpeg,png,webp}',
  { eager: true, import: 'default' },
)

export const userPhotos = Object.values(userImageModules)

export const userPhotoRows: string[][] = [0, 1, 2].map((col) =>
  userPhotos.filter((_, i) => i % 3 === col),
)
